import { getPopupOpened, setPopupOpened } from '@/stores/temp'
import { useMapEvent } from '@lc/libmap-react'
import { useDispatch, useSelector } from 'react-redux'

export function useClosePopupOnMapClick() {
	const dispatch = useDispatch()
	const popupOpened = useSelector(getPopupOpened)

	useMapEvent('click', () => {
		if (popupOpened) {
			dispatch(setPopupOpened(null))
		}
	})
}
